import { snakeCaseToTitleCase } from '@agilelab/plugin-wb-platform-common';
import { TextFieldProps } from '@material-ui/core';
import { ChangeEvent, forwardRef, Ref, useMemo } from 'react';
import { useEnvironmentsContext } from '../../context';
import { WbMultiSelect, WbSelect } from '../WbTextField';

interface Props {
  onChange: (env: string) => void;
  multi?: boolean;
  value: string | string[];
  ref: Ref<unknown>;
  label?: string;
}

export const SelectEnvironment = forwardRef(
  (
    props: Props & Omit<TextFieldProps, 'value' | 'onChange' | 'select'>,
    ref: Ref<any>,
  ) => {
    const {
      onChange,
      multi,
      value,
      children,
      label,
      disabled,
      ...textFieldProps
    } = props;
    const handleChange = (event: ChangeEvent<any>) => {
      onChange(event.target.value);
    };
    const { environmentList } = useEnvironmentsContext();
    const fetchedEnvs = environmentList.map(env => env.name);
    const displayedEnvs = useMemo(() => fetchedEnvs, [fetchedEnvs]);
    const isDisabled = disabled || !fetchedEnvs || fetchedEnvs.length === 0;

    return multi && Array.isArray(value) ? (
      <WbMultiSelect
        {...textFieldProps}
        disabled={isDisabled}
        ref={ref}
        value={value}
        id="select-env"
        label={label ?? 'Environment'}
        options={displayedEnvs || []}
        getOptionLabel={env => snakeCaseToTitleCase(env)}
        onChange={handleChange}
      />
    ) : (
      <WbSelect
        {...textFieldProps}
        disabled={isDisabled}
        ref={ref}
        value={value}
        id="select-env"
        label={label ?? 'Environment'}
        options={displayedEnvs || []}
        getOptionLabel={env => snakeCaseToTitleCase(env)}
        onChange={handleChange}
      />
    );
  },
);
